import { render, staticRenderFns } from "./TimeOnLocationSnippet.vue?vue&type=template&id=637460f8"
import script from "./TimeOnLocationSnippet.vue?vue&type=script&lang=js"
export * from "./TimeOnLocationSnippet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports